import { previousView } from '../view';
import { EActiveView } from '../../types/view';
import { trackShowTwoStepPasswordRegistration } from '../../utils/tracking';
import { changePassword } from '../authentication';
import { registerOrAuthorizeByToken, sendCode } from '../phoneAuth';
import { create as socialCreate } from '../social';
import { changeFlow } from '../flow';
import { EActiveFlow } from '../../types/flow';
export function applyAgreement() {
  return function (dispatch, getState, context) {
    var logger = context.logger;
    var _getState = getState(),
      view = _getState.view;
    var viewData = view.data;
    switch (viewData.prevView) {
      case EActiveView.AuthenticationRegistration:
        dispatch(changeFlow(EActiveFlow.Registration));
        dispatch(changePassword(''));
        dispatch(previousView());
        trackShowTwoStepPasswordRegistration();
        break;
      case EActiveView.PhoneAuth:
        dispatch(sendCode());
        break;
      case EActiveView.AccountSelect:
        dispatch(registerOrAuthorizeByToken());
        break;
      case EActiveView.SocialCreate:
        dispatch(previousView());
        dispatch(socialCreate());
        break;
      default:
        logger.warning("Invalid previous view \"".concat(viewData.prevView, "\" on applyAgreement step"));
    }
  };
}